package co.uk.paxes.pinpoint.web

import co.uk.paxes.pinpoint.web.DEBUG

internal fun log(message: String) {
    if (DEBUG) console.log(message)
}

internal fun logError(message: String) {
    if (DEBUG) console.error(message)
}

internal fun logWarn(message: String) {
    if (DEBUG) console.warn(message)
}
